import Socket from '../connection/socket';
import { Message } from '../stores/types/connection';
import { getState, socketListenerDispatch } from './socket-listener-main';
import { GreenroomState as GS } from '../stores/types/types';
import * as Actions from '../stores/actions/generate-content';
import { decodeHtmlEntities } from '../utils/utils';
import { MODAL_TEMPLATES } from '../stores/reducers/modal';

function socketLoadGeneratedContentById({ message }: Message) {
	const {
		SessionReducer: {
			token,
			meeting,
		},
	} = getState() as GS;

	if (token && meeting) {
		socketListenerDispatch(Actions.loadGeneratedContentById(token, meeting, message.id));
	}
}

function socketLoadGeneratedContent() {
	const {
		SessionReducer: {
			token,
			meeting,
		},
	} = getState() as GS;

	if (token && meeting) {
		socketListenerDispatch(Actions.loadGeneratedContent(token, meeting));
	}
}

function contentIsRegenerating({ message }: Message) {
	const { key, data, version } = message;

	if (!key || !data || version === undefined) {
		console.warn('no key/data/version when getting regerate content message', { key, data, version });
		return;
	}

	const {
		ModalReducer: {
			modalOpen,
			modalTemplate,
		},
	} = getState() as GS;

	// do not add initializing jobs for draft content if the shot modal is not open
	if (key.endsWith('-draft') && !(modalOpen && modalTemplate === MODAL_TEMPLATES.SHOT_BUILDER)) {
		return;
	}
	socketListenerDispatch(Actions.addInitializingJob(key, decodeHtmlEntities(data), version));
}

function contentRegeneratingError({ message }: Message) {
	const { key} = message;
	if (!key) {
		console.warn('no key when getting regerate content message', key);
	} else {
		socketListenerDispatch(Actions.removeInitializingJob(key));
	}
}

export default function GenerateContent(socket: Socket) {
	socket.addListener('load-generated-content-by-id', socketLoadGeneratedContentById);
	socket.addListener('load-generated-content', socketLoadGeneratedContent);
	socket.addListener('content-regenerating', contentIsRegenerating);
	socket.addListener('content-regenerating-error', contentRegeneratingError);
}
